<template>
  <div>
    <h3>Answers</h3>
    <!-- New Answer -->
    <v-row>
      <v-col cols="2">
        <v-text-field v-model="newAnswer.id" label="Answer Id"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="newAnswer.label" label="Label"></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-text-field v-model="newAnswer.value" label="Answer Value"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="newAnswer.image" label="Answer Image"></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-btn class="primary-btn" @click="add">Add</v-btn>
      </v-col>
    </v-row>

    <!-- Existing Validations -->
    <v-row v-for="(item, index) in answers" :key="'answer-'+index">
      <v-col cols="2">
        <v-text-field v-if="item.editing" v-model="item.id" label="Answer Id" />
        <span v-else>{{ item.id }}</span>
      </v-col>
      <v-col cols="2">
        <v-text-field v-if="item.editing" v-model="item.label" label="Label" />
        <span v-else>{{ item.label }}</span>
      </v-col>
      <v-col cols="2">
        <v-text-field v-if="item.editing" v-model="item.value" label="Answer Value" />
        <span v-else>{{ item.value }}</span>
      </v-col>
      <v-col cols="3">
        <v-text-field v-if="item.editing" v-model="item.image" label="Answer Image" />
        <span v-else>{{ item.image }}</span>
      </v-col>
      <v-col cols="3">
        <v-btn icon @click="duplicate(index)" v-show="!item.editing"><v-icon>mdi-content-copy</v-icon></v-btn>
        <v-btn icon @click="toggleEdit(index)">
          <v-icon>{{ item.editing ? 'mdi-check' : 'mdi-pencil' }}</v-icon>
        </v-btn>
        <v-btn icon @click="remove(index)" v-show="!item.editing"><v-icon>mdi-close</v-icon></v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      answers: this.value,
      newAnswer: {
        id: '',
        label: '',
        value: null,
        image: '',
        editing: false,
      }
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.answers = newValue;
      },
      deep: true
    },
    answers: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
      deep: true
    }
  },
  methods: {
    add() {
      const { id, label, value } = this.newAnswer;

      // Validation
      if (!label.trim()) {
        return;
      }
      if (value === null || value === '') {
        return;
      }
      const duplicate = this.answers.some(answer =>
        answer.value === value || (id && answer.id === id)
      );
      if (duplicate) {
        return;
      }

      this.answers.push({ ...this.newAnswer });
      this.newAnswer = {
        id: '',
        label: '',
        value: null,
        image: '',
        editing: false,
      };
    },
    toggleEdit(index) {
      this.$set(this.answers[index], 'editing', !this.answers[index].editing);
    },
    duplicate(index) {
      const newAnswer = { ...this.answers[index], editing: false };
      this.answers.splice(index + 1, 0, newAnswer);
    },
    remove(index) {
      this.answers.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/theme.scss";
.primary-btn {
  color: white;
  background-color: $ausloans-blue !important;
}
</style>